import React from 'react';
import { Hidden } from '@material-ui/core';
import { OneTimePayment } from './compensation-history-model';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';


interface OneTimePaymentViewProps {
    payment: OneTimePayment;
    effectiveDateOneTimeLabel: string;
    amountLabel: string;
    assessableLabel: string;
}
export const OneTimePaymentView = (props: OneTimePaymentViewProps) => {


    return (
        <div className='payment-table-row'>
            <div className='payment-table-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props?.effectiveDateOneTimeLabel}</p>
                </Hidden>
                <p>{getFormattedDate(props?.payment?.effective_date)}</p>
            </div>
            <div className='payment-table-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props?.amountLabel}</p>
                </Hidden>

                <p>{props?.payment?.amount}</p>
            </div>
            <div className='payment-table-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props?.assessableLabel}</p>
                </Hidden>
                <p>{props.payment?.assessable_compensation}</p>
            </div>
        </div>
    );
};